import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import notebookpicture from "../assets/contacts.png";
import { DataGrid, type GridColDef, type DataGridProps } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { type ContactListResponse } from '../dto/contacts-dto';
import { getContactListRequest } from "../api/contacts-api";


const Contacts = () => {
    const { t } = useTranslation();
    const [rows, setRows] = useState<ContactListResponse[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const columns: GridColDef<ContactListResponse>[] = [
        { field: 'lastname', headerName: t('contacts.surname'), width: 130 },
        { field: 'firstname', headerName: t('contacts.name'), width: 130 },
        { field: 'phone', headerName: t('contacts.phoneNumber'), width: 150 },
        {
            field: 'email',
            headerName: t('contacts.email'),
            width: 200,
            renderCell: (params) => {
                const email = params.value as string;
                return (
                    <a href={`mailto:${email}`} style={{ textDecoration: 'none', color: '#1976d2' }}>
                        {email}
                    </a>
                );
        },
    },
    ];

    useEffect(() => {
        const fetchContacts = async () => {
            setLoading(true);
            setError(null);
            try {
                const data = await getContactListRequest();
                setRows(data);
            } catch (err: any) {
                console.error('Error fetching contacts:', err);
                setError(err.response?.data?.message || err.message || 'Failed to load contacts');
            } finally {
                setLoading(false);
            }
        };

        fetchContacts();
    }, []);

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
                <img src={notebookpicture} alt={t('menu.contacts')} />
                <h2 style={{ margin: 0 }}>{t('menu.contacts')}</h2>
            </div>

            {error ? (
                <Typography color="error">{error}</Typography>
            ) : (
                <Box sx={{ width: '100%' }}>
                    <DataGrid
                        {...({
                            rows,
                            columns,
                            loading,
                            hideFooter: true,
                            autoHeight: true,
                            disableColumnMenu: true,
                            components: {
                                NoRowsOverlay: () => (
                                    <Typography variant="body2" sx={{ textAlign: 'center', mt: 2 }}>
                                        {loading ? t('contacts.loading') : t('contacts.noData')}
                                    </Typography>
                                ),
                            },
                        } as DataGridProps<ContactListResponse>)}
                    />
                </Box>
            )}
        </>
    );
};

export default Contacts;